/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IStripeCustomerBean', 'model/StripeCustomerMetadataBean', 'model/StripeDiscountBean', 'model/StripeSubscriptionBean', 'model/StripeTaxIdBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./IStripeCustomerBean'), require('./StripeCustomerMetadataBean'), require('./StripeDiscountBean'), require('./StripeSubscriptionBean'), require('./StripeTaxIdBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.IStripeCustomerBean = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.IStripeCustomerBean, root.BpmbuildProductionappspotcom.StripeCustomerMetadataBean, root.BpmbuildProductionappspotcom.StripeDiscountBean, root.BpmbuildProductionappspotcom.StripeSubscriptionBean, root.BpmbuildProductionappspotcom.StripeTaxIdBean);
  }
}(this, function(ApiClient, IStripeCustomerBean, StripeCustomerMetadataBean, StripeDiscountBean, StripeSubscriptionBean, StripeTaxIdBean) {
  'use strict';

  /**
   * The IStripeCustomerBean model module.
   * @module model/IStripeCustomerBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>IStripeCustomerBean</code>.
   * @alias module:model/IStripeCustomerBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>IStripeCustomerBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IStripeCustomerBean} obj Optional instance to populate.
   * @return {module:model/IStripeCustomerBean} The populated <code>IStripeCustomerBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('stripeType'))
        obj.stripeType = ApiClient.convertToType(data['stripeType'], 'String');
      if (data.hasOwnProperty('preferredLocales'))
        obj.preferredLocales = ApiClient.convertToType(data['preferredLocales'], 'String');
      if (data.hasOwnProperty('invoicePrefix'))
        obj.invoicePrefix = ApiClient.convertToType(data['invoicePrefix'], 'String');
      if (data.hasOwnProperty('invoiceSettingsValue'))
        obj.invoiceSettingsValue = ApiClient.convertToType(data['invoiceSettingsValue'], 'String');
      if (data.hasOwnProperty('balance'))
        obj.balance = ApiClient.convertToType(data['balance'], 'Number');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = IStripeCustomerBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('stripeDiscountId'))
        obj.stripeDiscountId = StripeDiscountBean.constructFromObject(data['stripeDiscountId']);
      if (data.hasOwnProperty('currency'))
        obj.currency = ApiClient.convertToType(data['currency'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('addressLine2'))
        obj.addressLine2 = ApiClient.convertToType(data['addressLine2'], 'String');
      if (data.hasOwnProperty('phone'))
        obj.phone = ApiClient.convertToType(data['phone'], 'String');
      if (data.hasOwnProperty('taxExempt'))
        obj.taxExempt = ApiClient.convertToType(data['taxExempt'], 'String');
      if (data.hasOwnProperty('city'))
        obj.city = ApiClient.convertToType(data['city'], 'String');
      if (data.hasOwnProperty('addressLine1'))
        obj.addressLine1 = ApiClient.convertToType(data['addressLine1'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('invoiceSettingsName'))
        obj.invoiceSettingsName = ApiClient.convertToType(data['invoiceSettingsName'], 'String');
      if (data.hasOwnProperty('liveMode'))
        obj.liveMode = ApiClient.convertToType(data['liveMode'], 'Boolean');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('stripeTaxId'))
        obj.stripeTaxId = ApiClient.convertToType(data['stripeTaxId'], [StripeTaxIdBean]);
      if (data.hasOwnProperty('sources'))
        obj.sources = ApiClient.convertToType(data['sources'], 'String');
      if (data.hasOwnProperty('country'))
        obj.country = ApiClient.convertToType(data['country'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('subscriptionsList'))
        obj.subscriptionsList = ApiClient.convertToType(data['subscriptionsList'], [StripeSubscriptionBean]);
      if (data.hasOwnProperty('delinquent'))
        obj.delinquent = ApiClient.convertToType(data['delinquent'], 'Boolean');
      if (data.hasOwnProperty('stripePaymentMethodId'))
        obj.stripePaymentMethodId = ApiClient.convertToType(data['stripePaymentMethodId'], 'String');
      if (data.hasOwnProperty('defaultPaymentMethodId'))
        obj.defaultPaymentMethodId = ApiClient.convertToType(data['defaultPaymentMethodId'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('stripeCustomerId'))
        obj.stripeCustomerId = ApiClient.convertToType(data['stripeCustomerId'], 'String');
      if (data.hasOwnProperty('shippingAddress'))
        obj.shippingAddress = ApiClient.convertToType(data['shippingAddress'], 'String');
      if (data.hasOwnProperty('metaData'))
        obj.metaData = StripeCustomerMetadataBean.constructFromObject(data['metaData']);
      if (data.hasOwnProperty('postalCode'))
        obj.postalCode = ApiClient.convertToType(data['postalCode'], 'String');
      if (data.hasOwnProperty('state'))
        obj.state = ApiClient.convertToType(data['state'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
    }
    return obj;
  }

  /**
   * @member {String} stripeType
   */
  exports.prototype.stripeType = undefined;

  /**
   * @member {String} preferredLocales
   */
  exports.prototype.preferredLocales = undefined;

  /**
   * @member {String} invoicePrefix
   */
  exports.prototype.invoicePrefix = undefined;

  /**
   * @member {String} invoiceSettingsValue
   */
  exports.prototype.invoiceSettingsValue = undefined;

  /**
   * @member {Number} balance
   */
  exports.prototype.balance = undefined;

  /**
   * @member {module:model/IStripeCustomerBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {module:model/StripeDiscountBean} stripeDiscountId
   */
  exports.prototype.stripeDiscountId = undefined;

  /**
   * @member {String} currency
   */
  exports.prototype.currency = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {String} addressLine2
   */
  exports.prototype.addressLine2 = undefined;

  /**
   * @member {String} phone
   */
  exports.prototype.phone = undefined;

  /**
   * @member {String} taxExempt
   */
  exports.prototype.taxExempt = undefined;

  /**
   * @member {String} city
   */
  exports.prototype.city = undefined;

  /**
   * @member {String} addressLine1
   */
  exports.prototype.addressLine1 = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {String} invoiceSettingsName
   */
  exports.prototype.invoiceSettingsName = undefined;

  /**
   * @member {Boolean} liveMode
   */
  exports.prototype.liveMode = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Array.<module:model/StripeTaxIdBean>} stripeTaxId
   */
  exports.prototype.stripeTaxId = undefined;

  /**
   * @member {String} sources
   */
  exports.prototype.sources = undefined;

  /**
   * @member {String} country
   */
  exports.prototype.country = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {Array.<module:model/StripeSubscriptionBean>} subscriptionsList
   */
  exports.prototype.subscriptionsList = undefined;

  /**
   * @member {Boolean} delinquent
   */
  exports.prototype.delinquent = undefined;

  /**
   * @member {String} stripePaymentMethodId
   */
  exports.prototype.stripePaymentMethodId = undefined;

  /**
   * @member {String} defaultPaymentMethodId
   */
  exports.prototype.defaultPaymentMethodId = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {String} email
   */
  exports.prototype.email = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} stripeCustomerId
   */
  exports.prototype.stripeCustomerId = undefined;

  /**
   * @member {String} shippingAddress
   */
  exports.prototype.shippingAddress = undefined;

  /**
   * @member {module:model/StripeCustomerMetadataBean} metaData
   */
  exports.prototype.metaData = undefined;

  /**
   * @member {String} postalCode
   */
  exports.prototype.postalCode = undefined;

  /**
   * @member {String} state
   */
  exports.prototype.state = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/IStripeCustomerBean.js